function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { StreamingProtocol } from '../player/playout-data';
export var PSF_PROXY_URL = 'https://int-stream-format.mssai-dev.nbcuni.com/manifest.psf?url=';
export var PeacockStreamingFormatProxy = /*#__PURE__*/ function() {
    "use strict";
    function PeacockStreamingFormatProxy() {
        _class_call_check(this, PeacockStreamingFormatProxy);
    }
    _create_class(PeacockStreamingFormatProxy, null, [
        {
            key: "getModifiedPlayoutData",
            value: function getModifiedPlayoutData(playoutData) {
                var _playoutData_stream;
                if (((_playoutData_stream = playoutData.stream) === null || _playoutData_stream === void 0 ? void 0 : _playoutData_stream.protocol) !== StreamingProtocol.DASH) {
                    throw new Error('PSF proxy only supports conversion from DASH');
                }
                return _object_spread_props(_object_spread({}, playoutData), {
                    stream: _object_spread_props(_object_spread({}, playoutData.stream), {
                        protocol: StreamingProtocol.PSF
                    }),
                    cdns: playoutData.cdns.map(function(cdn) {
                        return _object_spread_props(_object_spread({}, cdn), {
                            url: "".concat(PSF_PROXY_URL).concat(encodeURIComponent(cdn.url))
                        });
                    })
                });
            }
        }
    ]);
    return PeacockStreamingFormatProxy;
}();

//# sourceMappingURL=psf-proxy.js.map